import { toast } from "react-toastify";
import {
  useCurrentUser,
  useLogout,
  useFetchOrganizationUsers,
} from "utils/hooks";
import ReactGA from "react-ga4";
interface Member {
  email: string;
  role: { value: string; label: string } | null;
  error?: string;
}

const useAddUsersToOrganization = (organizationId: string) => {
  const { logOut } = useLogout();
  const { user } = useCurrentUser();
  const { fetchOrganizationUsers } = useFetchOrganizationUsers();

  const convertUsersToRQLFormat = (user: Member) => {
    if (user) {
      return `{ 
          email: "${user.email}",
          role: "${user?.role?.value}",
        }`;
    }

    return;
  };

  const formattedUsers = (users: Member[]) =>
    users?.map(convertUsersToRQLFormat) || [];

  const addUsersToOrganization = async (args: Member[]) => {
    if (!args || !organizationId) {
      return null;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
              mutation {
                addUsersToOrganization(
                users: [${formattedUsers(args)}],
                organizationId: "${organizationId}",
                ) {
                  success
                  addedEmails
                  errors {
                      email
                      message
                  }
                }
              }
            `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "invite_organization_therapist",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        const { addedEmails, errors } = resData.data.addUsersToOrganization;
        if (addedEmails && addedEmails.length > 0) {
          toast(`${addedEmails.join(", ")} invited to organization`);
          ReactGA.event("users_added_to_organization_success", {
            user_id: user?.id,
            organization_id: organizationId,
            added_emails: addedEmails.join(", "),
          });
        }
        if (errors && errors.length > 0) {
          errors.map((e: { email: string; message: string }) =>
            toast.error(`${e.email} not invited. ${e.message}`)
          );
        }
        fetchOrganizationUsers(organizationId);
        return resData.data.addUsersToOrganization;
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    addUsersToOrganization,
  };
};

export default useAddUsersToOrganization;
